/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  DeclineOnboardingNotRelatedMutationRequest,
  DeclineOnboardingNotRelatedMutationResponse,
} from "../types/DeclineOnboardingNotRelated.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const declineOnboardingNotRelatedMutationKey = () =>
  [{ url: "/v1/user-onboarding/decline-not-related" }] as const

export type DeclineOnboardingNotRelatedMutationKey = ReturnType<
  typeof declineOnboardingNotRelatedMutationKey
>

/**
 * @description Blocks onboarding for the authenticated supplier, records decline audit on the invite contact, and reassigns each open request to its transferrer (InformationRequest.createdById) with ORG_ADMIN fallback. Does not deactivate supplier mappings.
 * @summary Decline onboarding for unrelated invite
 * {@link /v1/user-onboarding/decline-not-related}
 */
export async function declineOnboardingNotRelated(
  data: DeclineOnboardingNotRelatedMutationRequest,
  config: Partial<RequestConfig<DeclineOnboardingNotRelatedMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeclineOnboardingNotRelatedMutationResponse,
    ResponseErrorConfig<Error>,
    DeclineOnboardingNotRelatedMutationRequest
  >({
    method: "POST",
    url: `/v1/user-onboarding/decline-not-related`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function declineOnboardingNotRelatedMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DeclineOnboardingNotRelatedMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = declineOnboardingNotRelatedMutationKey()
  return mutationOptions<
    ResponseConfig<DeclineOnboardingNotRelatedMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeclineOnboardingNotRelatedMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return declineOnboardingNotRelated(data, config)
    },
  })
}

/**
 * @description Blocks onboarding for the authenticated supplier, records decline audit on the invite contact, and reassigns each open request to its transferrer (InformationRequest.createdById) with ORG_ADMIN fallback. Does not deactivate supplier mappings.
 * @summary Decline onboarding for unrelated invite
 * {@link /v1/user-onboarding/decline-not-related}
 */
export function useDeclineOnboardingNotRelated<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeclineOnboardingNotRelatedMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeclineOnboardingNotRelatedMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<DeclineOnboardingNotRelatedMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? declineOnboardingNotRelatedMutationKey()

  const baseOptions = declineOnboardingNotRelatedMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeclineOnboardingNotRelatedMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeclineOnboardingNotRelatedMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeclineOnboardingNotRelatedMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeclineOnboardingNotRelatedMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeclineOnboardingNotRelatedMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeclineOnboardingNotRelatedMutationRequest },
    TContext
  >
}
